import { Head, Link } from "@inertiajs/react"
import { useTranslation } from "react-i18next"

import { RewardForm } from "@/components/rewards/reward-form"
import type { RewardFormReward } from "@/components/rewards/reward-form"
import { Button } from "@/components/ui/button"
import AppLayout from "@/layouts/app-layout"
import { rewardPath, rewardsPath } from "@/routes"

/**
 * OKS-59 — Standalone Edit Reward page.
 *
 * Mirror of `New.tsx`. The Sheet-based Edit on `Brand/Rewards/Index`
 * (via `?edit=:id`) is the primary UX; this page exists for direct
 * route entry. Both paths share `<RewardForm>`.
 */
interface RewardsEditProps {
  reward: RewardFormReward & { id: number }
  kinds: string[]
}

export default function RewardsEdit({ reward, kinds }: RewardsEditProps) {
  const { t } = useTranslation()

  return (
    <AppLayout>
      <Head title={t("rewards.form.edit_title")} />
      <div className="mx-auto flex max-w-2xl flex-col gap-6 p-6">
        <header className="space-y-1">
          <h1 className="text-foreground text-2xl font-semibold tracking-tight">
            {t("rewards.form.edit_title")}
          </h1>
          <p className="text-muted-foreground text-sm">
            {t("rewards.form.description")}
          </p>
        </header>

        <RewardForm
          reward={reward}
          kinds={kinds}
          action={rewardPath(reward.id)}
          method="patch"
        />

        <div className="flex justify-end">
          <Button asChild variant="ghost">
            <Link href={rewardsPath()}>{t("rewards.form.cancel")}</Link>
          </Button>
        </div>
      </div>
    </AppLayout>
  )
}
